const googleScriptURL = "https://script.google.com/macros/s/AKfycbxZDJYlqgQau9GGB-PuddQXYA3gtv15Ur43Br2Aq0xg9hzfP6rR-LyF4q3XfdgN9jRRuQ/exec";

// Open modals
// document.querySelectorAll(".openModalBtn").forEach((btn) => {
//   btn.addEventListener("click", function () {
//     const modalId = btn.getAttribute("data-modal-id");
//     const modalOverlay = document.querySelector(`.Ma-form-container-overlay[data-modal-id="${modalId}"]`);
//     if (modalOverlay) {
//       modalOverlay.classList.add("active");
//       document.body.style.overflow = "hidden";
//     }
//   });
// });

// document.querySelectorAll(".closeModalBtn").forEach((btn) => {
//   btn.addEventListener("click", function () {
//     const modalOverlay = btn.closest(".Ma-form-container-overlay");
//     modalOverlay.classList.remove("active");
//     document.body.style.overflow = "";
//     modalOverlay.querySelector(".loadingContainer").style.display = "none";
//     modalOverlay.querySelector(".successMessage").style.display = "none";
//   });
// });

// Handle forms
document.querySelectorAll(".appointmentForm").forEach((form) => {
  const modalOverlay = form.closest(".Ma-form-container-overlay");
  const loadingContainer = modalOverlay.querySelector(".loadingContainer");
  const successMessage = modalOverlay.querySelector(".Ma-form-container-success-message");
  const timeInput = form.querySelector("#appointmentTime");
  const dateFormContainer = form.querySelector(".Ma-form-container");
  const dateInput = form.querySelector("#preferred_date");
  const locationSelect = form.querySelector("#locationSelect");

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    loadingContainer.style.display = "flex";

    // Combine date and time into one field
    const appointmentDateTime = `${dateInput.value} ${timeInput.value}`;

    const formData = new FormData(form);
    
    // Explicitly set required fields in FormData
    formData.set("appointment", appointmentDateTime);
    formData.set("location", locationSelect.value);

    fetch(googleScriptURL, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.text())
      .then(() => {
        loadingContainer.style.display = "none";
        successMessage.style.display = "block";
        dateFormContainer.style.display = "none";
        form.reset();
        form.querySelector('input[name="updates"]').checked = true;
      })
      .catch((error) => {
        console.error("Error:", error);
        loadingContainer.style.display = "none";
        alert("An error occurred. Please try again.");
      });
  });
});

// Attach event listener to all close buttons within success messages
document.querySelectorAll(".success-message-close").forEach((btn) => {
  btn.addEventListener("click", function () {
    // Hide the success message container
    const successMessage = this.closest(".successMessage");
    if (successMessage) {
      successMessage.style.display = "none";
    }
  });
});


